import { IPagination } from "../../data/AppInterface";
import { TReactSetState, TSetPaginationFn } from "../../data/AppType";
import {
  DELETE_GALLERY_DIRECTORY_ITEM,
  GET_ALL_GALLERY_DIRECTORY_ITEM,
} from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_LOCAL_UNKNOWN_ERROR_OCCURRED,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  generatePaginationFromApiRes,
  handleError,
  resetPaginationWithPpr,
  sweetAlertError,
  sweetAlertSuccess,
  toastError,
} from "../../utils/AppFunctions";

export interface IGalleryDirectoryItemList {
  id: string;
  media_url: string;
}

export const fetchGalleryDirectoryItemList = async (
  id: string,
  setLoading: TReactSetState<boolean>,
  setGalleryDirectoryItemList: TReactSetState<IGalleryDirectoryItemList[]>,
  setPagination: TSetPaginationFn,
  pagination: IPagination,
  galleryDirectoryItemList: IGalleryDirectoryItemList[],
  isScroll: boolean
) => {
  setLoading(true);
  try {
    const galleryDirectoryItem = await GET_ALL_GALLERY_DIRECTORY_ITEM(
      pagination,
      id
    );
    if (
      galleryDirectoryItem &&
      galleryDirectoryItem.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      if (
        galleryDirectoryItemList &&
        galleryDirectoryItemList.length > 0 &&
        isScroll
      ) {
        setGalleryDirectoryItemList([
          ...galleryDirectoryItemList,
          ...(galleryDirectoryItem?.data?.item ?? []),
        ]);
      } else setGalleryDirectoryItemList(galleryDirectoryItem.data.item);
      setPagination({
        ...pagination,
        ...generatePaginationFromApiRes(galleryDirectoryItem.data.pagination),
      });
    } else {
      setGalleryDirectoryItemList([]);
      setPagination({
        ...pagination,
        ...resetPaginationWithPpr(pagination.perPageRows),
      });
      toastError(galleryDirectoryItem.message);
    }
  } catch (e: any) {
    toastError(MESSAGE_LOCAL_UNKNOWN_ERROR_OCCURRED);
    handleError(e, "fetchGalleryDirectoryItemList");
  } finally {
    setLoading(false);
  }
};

export const deleteGalleryDirectoryItem = async (id: string) => {
  try {
    const deletedData = await DELETE_GALLERY_DIRECTORY_ITEM(id);
    if (deletedData && deletedData.code === DEFAULT_STATUS_CODE_SUCCESS) {
      sweetAlertSuccess({ message: deletedData.message });
      return true;
    } else {
      sweetAlertError({
        message: deletedData.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
      return false;
    }
  } catch (e: any) {
    handleError(e, "deleteGalleryDirectoryItem");
    return false;
  }
};
